import { Wrapper } from './header.styles';

import { VENDOR_BUSINESS_NAME } from '../constants';

import bubbleJoyIcon from '../static/icon.svg';

export default function Header() {
  return (
    <Wrapper>
      <img alt={VENDOR_BUSINESS_NAME} height={170} src={bubbleJoyIcon} width={170} />
    </Wrapper>
  );
}
